import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

export interface MutliVideoPlayerStyle {
    videoContainer?: InjectableCss;
}

interface OwnProps {
    videoUrl: string;
    videoHeight?: string | undefined;
    autoplay?: string;
    playVideo: boolean;
}

type Props = OwnProps;

export const mutliVideoPlayerStyle: MutliVideoPlayerStyle = {
    videoContainer: {
        css: css`
            width: 100%;
            height: 100%;
        `,
    },
};

const styles = mutliVideoPlayerStyle;

const MultiVideoPlayer = ({ videoUrl, videoHeight, autoplay = "0", playVideo }: Props) => {
    const h = `${videoHeight ?? "500"}px`;
    if(!playVideo){
        return;
    }
    return (
        <StyledWrapper {...styles.videoContainer}>
            {videoUrl.includes("youtube.com") || videoUrl.includes("youtu.be") ? (
                // YouTube Embed
                <iframe
                    width="100%"
                    height={h}
                    src={`https://www.youtube.com/embed/${
                        videoUrl.includes("v=") ? `${new URL(videoUrl).searchParams.get("v")}?` : `${videoUrl.split("/").pop()}&`
                    }autoplay=${autoplay}&mute=1&playsinline=1&rel=0`}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                ></iframe>
            ) : videoUrl.includes("vimeo.com") ? (
                // Vimeo Embed
                <iframe
                    src={`https://player.vimeo.com/video/${videoUrl.split("/").pop()}?autoplay=${autoplay}&mute=1`}
                    width="100%"
                    height={h}
                    frameBorder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowFullScreen
                    title="Vimeo video player"
                ></iframe>
            ) : (
                // Direct file (mp4, mov, webm, etc.)
                <video style={{ maxWidth: "100%", width: "100%" }} height={h} controls>
                    <source src={videoUrl} />
                </video>
            )}
        </StyledWrapper>
    );
};

export default MultiVideoPlayer;
